import React, { useState, useEffect } from "react";
import { ControlsSection, CTAButton, Header, Styled } from "./styled";
import { CiFilter } from "react-icons/ci";
import { MdOutlineFileDownload } from "react-icons/md";
import { FaChevronDown } from "react-icons/fa";
import { FiSearch } from "react-icons/fi";
import videosService from "../../../../../services/videos";
import { message, Input } from "antd";
import VideoContainer from "../../../videos_container/VideoContainer";
import { SearchBarContainer, SearchInput } from "../../../admin/videos/styled";
import { CustomSearchContainer } from "../../../../table-item";

const Videos = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchGroupVideos = async () => {
    try {
      setLoading(true);
      const response = await videosService.getGroupVideo();
      // console.log("Group videos response:", response);

      if (response?.data?.videos?.results) {
        const transformedVideos = response.data.videos.results.map((video) => ({
          id: video._id,
          title: video.title || "Untitled Video",
          description: video.description || "",
          videoUrl: video.videoUrl || "",
          specialty: video.specialty || "General",
          tags: video.tags || [],
          customTags: video.customTags || [],
          duration: video.duration || 0,
          hospital: video.hospital,
          generalLibrary: video.generalLibrary || false,
          patientCount: video.patient?.length || 0,
          physicianCount: video.physician?.length || 0,
          referenceMasterVideoId: video.referenceMasterVideoId || null,
          createdAt: video.createdAt,
          updatedAt: video.updatedAt,
          // Add physician info if available
          author: video.physician?.[0]?.name || "Unknown Author",
          position:
            video.physician?.[0]?.specialty || video.specialty || "General",
          views: video.patient?.length || 0,
        }));
        setVideos(transformedVideos);
      } else {
        setVideos([]);
      }
    } catch (error) {
      setVideos([]);
    } finally {
      setLoading(false);
    }
  };

  const filteredVideos = (videos || []).filter((video) => {
    const search = searchTerm.toLowerCase();
    return (
      (video.title || "").toLowerCase().includes(search) ||
      (video.author || "").toLowerCase().includes(search) ||
      (video.position || "").toLowerCase().includes(search) ||
      (video.specialty || "").toLowerCase().includes(search)
    );
  });

  // Fetch videos on component mount
  useEffect(() => {
    fetchGroupVideos();
  }, []);

  return (
    <Styled.Wrapper>
      <Header>
        <div className="row1">
          <div className="heading_text">Group Videos</div>
        </div>
        {/* <div className="row2">Videos across all your managed groups.</div> */}
      </Header>

      <CustomSearchContainer style={{ marginTop: "15px", marginBottom:"15px" }}>
        <FiSearch className="ml-5" color={"var(--secondary-text-color)"} style={{position: "absolute", zIndex: 1}}/>
        <Input
          type="text"
          placeholder="Search videos..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </CustomSearchContainer>

      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "300px",
            fontSize: "16px",
            color: "var(--secondary-text-color)",
          }}
        >
          Loading videos...
        </div>
      ) : filteredVideos.length === 0 ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "300px",
            fontSize: "16px",
            color: "var(--secondary-text-color)",
          }}
        >
          {searchTerm
            ? "No videos found matching your search"
            : "No videos available for this group"}
        </div>
      ) : (
        <VideoContainer
          videos={{ results: filteredVideos }}
          isLoading={loading}
        />
      )}
    </Styled.Wrapper>
  );
};

export default Videos;
